<template>
	<div class="wais">
		<div class="wai">
			<div class="title">
				<div class="blue"></div>
				<div style="flex: 1;">基本设置</div>
			</div>
			<!--  -->
			<el-form style="margin-left:30px;" label-width="150px" label-position="left">
				<el-form-item label="门店名称">
					<el-input size="small" maxlength="12" show-word-limit v-model="list.title" style="width:378px;"
						placeholder="请输入门店名称,不能超过12个字"></el-input>
				</el-form-item>
				<el-form-item label="背景图">
					<upload v-model="list.background" style="width:132px;height:132px" />
				</el-form-item>
				<el-form-item label="门店类型">
					<div style="display: flex;margin-top:15px;">
						<el-radio v-model="list.type" label="1">普通店</el-radio>
						<el-radio v-model="list.type" label="2">合作店</el-radio>
						<el-radio v-model="list.type" label="3">联名店</el-radio>
						<el-radio v-model="list.type" label="4">旗舰店</el-radio>
						<el-radio v-model="list.type" label="5">地铁店</el-radio>
						<el-radio v-model="list.type" label="6">加盟店</el-radio>
					</div>
				</el-form-item>
				<el-form-item label="显示价格">
					<el-input-number v-model="list.price" size="small" :precision="2"></el-input-number>
				</el-form-item>
				<el-form-item label="业绩计算">
					<div style="display: flex;margin-top:15px;">
						<el-radio v-model="list.isMember" label="0">常规</el-radio>
						<el-radio v-model="list.isMember" label="1">实收</el-radio>
					</div>
				</el-form-item>
				<el-form-item label="详情页文本">
					<el-input type="textarea" v-model="list.detailText" style="width: 378px;"></el-input>
				</el-form-item>
				<el-form-item label="参与用户分销">
					<div style="display: flex;margin-top:15px;">
						<el-radio v-model="list.isDist" label="0">否</el-radio>
						<el-radio v-model="list.isDist" label="1">是</el-radio>
					</div>
				</el-form-item>
        <el-form-item label="所属平台">
          <div style="display: flex;margin-top:15px;">
            <el-radio v-model="list.platform" v-for="item in platform" :key="item.value" :label="item.value">{{item.label}}</el-radio>
          </div>
        </el-form-item>
        <el-form-item label="收款方式">
          <div style="display: flex;margin-top:15px;">
            <el-radio v-model="list.payType" label="weixin">微信支付</el-radio>
            <el-radio v-model="list.payType" label="native">微信收款码</el-radio>
          </div>
        </el-form-item>
        <el-form-item label="微信商户号">
          <el-select clearable v-model="list.mchId" placeholder="请选择" size="small">
            <el-option v-for="item in wxMchIds" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
				<el-form-item label="店铺类型">
					<div style="display: flex;margin-top:15px;">
						<el-radio v-model="list.storeType" label="1">单剪店</el-radio>
						<el-radio v-model="list.storeType" label="2">染护店</el-radio>
					</div>
				</el-form-item>
				<el-form-item label="门店营业期限">
					<div>
						<el-radio v-model="list.longTime" label="1">长期</el-radio>
					</div>
					<div>
						<el-radio v-model="list.longTime" label="0">
							<el-date-picker size="small" v-model="list.businesstime" value-format="yyyy-MM-dd"
								type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
							</el-date-picker>
						</el-radio>
					</div>
				</el-form-item>
				<el-form-item label="门店营业时间">
					<!-- 工作日 -->
					<div>
						<span>工作日：</span>
						<el-time-select style="width: 130px;" size="small" v-model="list.zaoStart" :picker-options="{
										start: '05:00',
										step: '00:10',
										end: '24:00'
									}" placeholder="选择时间">
						</el-time-select>
						<span style="margin-left: 10px;margin-right: 10px;">至</span>
						<el-time-select style="width: 130px;" size="small" v-model="list.zaoEnd" :picker-options="{
										start: '00:00',
										step: '00:10',
										end: '24:00'
									}" placeholder="选择时间">
						</el-time-select>
					</div>
					<!-- 周末 -->
					<div style="display: flex;">
						<span style="display: flex;">周<div style="width: 16px;"></div>末：</span>
						<el-time-select style="width: 130px;" size="small" v-model="list.wanStart" :picker-options="{
										start: '05:00',
										step: '00:10',
										end: '24:00'
									}" placeholder="选择时间">
						</el-time-select>
						<span style="margin-left: 10px;margin-right: 10px;">至</span>
						<el-time-select style="width: 130px;" size="small" v-model="list.wanEnd" :picker-options="{
										start: '00:00',
										step: '00:10',
										end: '24:00'
									}" placeholder="选择时间">
						</el-time-select>
					</div>
					<div style="display: flex;">
						<span>休息日：</span>
						<el-checkbox-group v-model="list.restDay" multiple="">
							<el-checkbox v-for="item in restList" :label="item.id">{{item.name}}</el-checkbox>
						</el-checkbox-group>
					</div>
				</el-form-item>
				<el-form-item label="门店就餐时间">
					<!-- 午餐 -->
					<div>
						<span> 午餐：</span>
						<el-time-select style="width: 130px;" size="small" v-model="list.lunchTimeStart"
							:picker-options="{
										start: '08:00',
										step: '00:15',
										end: '24:00'
									}" placeholder="选择时间">
						</el-time-select>
						<span style="margin-left: 10px;margin-right: 10px;">至</span>
						<el-time-select style="width: 130px;" size="small" v-model="list.lunchTimeEnd" :picker-options="{
										start: '08:15',
										step: '00:15',
										end: '24:00'
									}" placeholder="选择时间">
						</el-time-select>
						<span style="margin-left: 10px;margin-right: 10px;">中点时间：</span>
						<el-time-select style="width: 130px;" size="small" v-model="list.lunchTimeMiddle"
							:picker-options="{
										start: '08:15',
										step: '00:15',
										end: '24:00'
									}" placeholder="选择时间">
						</el-time-select>
					</div>
					<!-- 晚餐 -->
					<div>
						<span> 晚餐：</span>
						<!-- <el-time-picker size="small"  is-range v-model="list.supperTime" value-format="yyyy-MM-dd"
							type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
						</el-time-picker> -->
						<el-time-select style="width: 130px;" size="small" v-model="list.supperTimeStart"
							:picker-options="{
										start: '13:00',
										step: '00:15',
										end: '24:00'
									}" placeholder="选择时间">
						</el-time-select>
						<span style="margin-left: 10px;margin-right: 10px;">至</span>
						<el-time-select style="width: 130px;" size="small" v-model="list.supperTimeEnd" :picker-options="{
										start: '13:15',
										step: '00:15',
										end: '24:00'
									}" placeholder="选择时间">
						</el-time-select>
						<span style="margin-left: 10px;margin-right: 10px;">中点时间：</span>
						<el-time-select style="width: 130px;" size="small" v-model="list.supperTimeMiddle"
							:picker-options="{
										start: '13:15',
										step: '00:15',
										end: '24:00'
									}" placeholder="选择时间">
						</el-time-select>
					</div>
					<!-- <div>
						<el-radio v-model="list.longTime" label="1">是否轻餐</el-radio>
					</div> -->
				</el-form-item>
				<el-form-item label="门店标识">
					<el-input size="medium" v-model="list.tag" style="width:378px;" placeholder="请输入门店标识"></el-input>
				</el-form-item>
				<!--<el-form-item label="门店优惠">
					<div style="display: flex;">
						<upload v-model="list.discountImg" class="el-tabs-pane-upload"  ref="sss" style="width: 50px; height: 35px;margin-top: 3px;margin-right: 10px;" />
						<el-input size="medium" v-model="list.discountTitle" style="width:378px;" placeholder="请输入门店优惠文字"></el-input>
						<el-input size="medium" v-model="list.discountUrl" style="width:378px;" placeholder="调转页面路径"></el-input>
					</div>
				</el-form-item> -->
				<el-form-item label="门店地址">
					<div style="display: flex;">
						<el-select filterable v-model="list.city" style="width: 120px;" placeholder="请选择" size="small">
							<el-option v-for="item in city" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
						<el-input v-model="list.address" size="small" style="width:300px;margin-left: 10px;"
							placeholder="输入详细地址"> </el-input>
					</div>
				</el-form-item>
				<el-form-item label="选择门店坐标">
					<el-input v-model="addressKeyword" size="small" style="width:300px;margin-left: 10px;"
						placeholder="输入关键字"></el-input>
					<div class="map">
						<div style="display: flex;">
							<span>经度：</span>
							<el-input size="small" style="width:180px;" v-model="center.lng" placeholder="经度">
							</el-input>
							<span style="margin-left:30px;">纬度：</span>
							<el-input size="small" style="width: 180px;" v-model="center.log" placeholder="纬度">
							</el-input>
						</div>
						<baidu-map NavigationControl="center" class="bmView" :scroll-wheel-zoom="true"
							@click="getClickInfo" center="广州市" :zoom="14" ak="IF7MiqCFrw8GYPRpxKUKhObAVCEbQThZ">
							<bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-scale>
							<!--缩放控件-->
							<bm-navigation anchor="BMAP_ANCHOR_BOTTOM_RIGHT"></bm-navigation>
							<bm-view style="width:600px; height:350px; flex: 1"></bm-view>
							<bm-local-search :keyword="addressKeyword" :auto-viewport="true" style="display: none">
							</bm-local-search>
						</baidu-map>
					</div>
				</el-form-item>
				<div></div>
				<el-form-item label="门店当前状态">
					<el-select v-model="list.state" style="width: 120px;" placeholder="请选择" size="small">
						<el-option v-for="item in statelist" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="暂停营业通告">
					<el-input size="medium" v-model="list.stopMsg" style="width:378px;"
						placeholder="请输入门店暂停营业通告"></el-input>
				</el-form-item>
        <el-form-item label="广告跳转小程序">
          <div style="display: flex;margin-top:15px;">
            <el-radio v-model="list.adsTargetType" :label="0">不启用</el-radio>
            <el-radio v-model="list.adsTargetType" :label="1">大众点评</el-radio>
            <el-radio v-model="list.adsTargetType" :label="2">美团</el-radio>
          </div>
        </el-form-item>
        <el-form-item label="广告跳转小程序路径">
          <el-input v-model="list.adsTargetPath" size="small" placeholder="请输入广告跳转小程序路径"></el-input>
        </el-form-item>
        <el-form-item label="大众点评小程序路径">
          <el-input v-model="list.dazhongPath" size="small" placeholder="请输入大众点评小程序路径"></el-input>
        </el-form-item>
        <el-form-item label="代金券广告图片">
          <upload v-model="list.adsVoucherImg" style="width:120px;height:90px" />
        </el-form-item>
        <el-form-item label="多国语言">
          <el-checkbox-group v-model="checkLang">
            <el-checkbox label="CN" disabled>中文</el-checkbox>
            <el-checkbox label="EN">英文</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
				<!-- <el-form-item label="剪发服务" >
							<el-tag v-for="item in serviceIds" :key="item.id" style="margin-right:10px">
								{{ item.title }}
							</el-tag>
							<el-button type="text" style="color:#999; border:2px dashed; width:100px;" @click="serviceShow=true">+选择服务</el-button>
						</el-form-item> -->
				<div v-if="showfax">
					<div class="title">
						<div class="blue"></div>
						<div style="flex: 1;">发型师配备</div>
					</div>
					<!--发型师表格  -->
					<div class="addhair" @click="addhair">+添加发型师</div>
					<el-table :cell-style="{'text-align':'center'}"
						:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable"
						:data="tableData" tooltip-effect="dark" style="width: 100%">
						<el-table-column prop="id" label="员工编号"></el-table-column>
						<el-table-column prop="avatar" label="头像">
							<template slot-scope="scope">
								<img v-if="scope.row.avatar" class="headlike" :src="scope.row.avatar" />
								<span v-if="!scope.row.avatar">暂无</span>
							</template>
						</el-table-column>
						<el-table-column prop="name" label="姓名"></el-table-column>
						<el-table-column prop="telphone" label="手机号"></el-table-column>
						<el-table-column prop="type" label="职位">
							<template slot-scope="scope">
								{{ scope.row.type | typeFormat}}
							</template>
						</el-table-column>
						<el-table-column prop="joinTime" label="到店时间">
							<template slot-scope="scope">
								<span v-if="scope.row.joinTime">{{ scope.row.joinTime.substring(0, 10)}}</span>
								<span v-if="!scope.row.joinTime">暂无</span>
							</template>
						</el-table-column>
						<el-table-column prop="status" label="状态">
							<template slot-scope="scope">
								{{ scope.row.status | statusFormat}}
							</template>
						</el-table-column>
						<el-table-column width="120" label="操作">
							<template slot-scope="scope">
								<el-button type="text" @click="changesto(scope.row.id)">调店</el-button>
								<el-button type="text" @click="deletes(scope.row.id)">
									<span style="color: red;">离职</span>
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-form>
			<div class="button_s">
				<el-button @click="goback">取 消</el-button>
				<el-button type="primary" @click="addsto">保 存</el-button>
			</div>
		</div>
		<!-- 添加发型师弹出框 -->
		<el-dialog title="发型师" :visible.sync="dialogVisible" width="700px">
			<div style="margin-top: -20px;margin-bottom: 10px;display: flex;">
				<el-input size="small" style="width: 200px;margin-right: 8px;" v-model="hairlist.faxingshi"
					placeholder="请输入发型师名称"></el-input>
				<el-button type="primary" size="small" @click="hairlist.page = 1; gethairs()">搜 索</el-button>
			</div>
			<el-table :header-cell-style="{background:'#F7F7F7','text-align':'center'}"
				:cell-style="{'text-align':'center'}" :data="barber" border style="width: 100%">
				<el-table-column label="选择" width="50">
					<template slot-scope="scope">
						<div style="width: 20px;overflow: hidden;margin: auto;">
							<el-checkbox class="checkeds" v-model="hairchecked" :label="scope.row.id"></el-checkbox>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="name" label="发型师" width="180"></el-table-column>
				<el-table-column prop="type" label="职位" width="180">
					<template slot-scope="scope">
						{{ scope.row.type | typeFormat}}
					</template>
				</el-table-column>
				<el-table-column prop="levelTitle" label="等级"></el-table-column>
			</el-table>
			<div class="pages">
				<el-pagination @current-change="handleCurrentChange" :current-page="hairlist.page" :page-sizes="[10]"
					:page-size="hairlist.size" layout="total, prev, pager, next" :total="hairlist.total">
				</el-pagination>
			</div>
			<span class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="addstorehair">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="更换门店" :visible.sync="changestore" width="35%">
			<span>请选择门店：
				<el-select v-model="cityss" filterable placeholder="请选择">
					<el-option v-for="item in stolist" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-button @click="cgstore" type="primary" style="margin-left: 10px;">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="选择服务" :visible.sync="serviceShow" width="20%">
			<div v-for="item in serviceList" :key="item.id">
				<el-checkbox v-model="serviceIds" :label="item">{{ item.title }}</el-checkbox>
			</div>
			<div style="position: relative; left:70%;">
				<el-button type="primary" @click="serviceShow=false">确认</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import upload from "../../compents/upload/upload.vue"
  import coordtransform from 'coordtransform'
	export default {
		components: {
			upload
		},
		data() {
			return {
				lunchTimeStart: "", //晚餐时间
				serviceList: [],
				serviceShow: false,
				serviceIds: [],
				hairlist: {
					faxingshi: "",
					total: 0,
					page: 1,
					size: 10
				},
				workid: "", //员工id
				cityss: "",
				stolist: [],
				changestore: false, //更换门店
				showfax: false,
				faxingshi: "",
				fax: [{
					label: "高级发型师",
					value: "1"
				}, {
					label: "星级发型师",
					value: "2"
				}, {
					label: "资深发型师",
					value: "3"
				}],
				hairchecked: [],
				barber: [],
				list: {
					title: "", //门店名称
					background: undefined,
					type: '1', //门店类型
					isMember: '1', //常规
					storeType: '1', //1单剪店 2染护店
					isDist: '1', //0不参与分销 1参与分销
					longTime: "1", //是否是长期
					businesstime: "", //不是长期则有门店运营时间
					state: "", //门店状态
					tag: "", //门店标识
					address: "", //门店详细地址
					city: "", //门店所在城市
					zaoStart: '',
					wanEnd: '',
					workdayStart: "", //工作日开始时间
					workdayEnd: "", //工作日结束时间
					weekStart: "", //周末开始时间
					weekEnd: "", //周末结束时间
					restDay: [],
					detailText: "", //详情页文本
					lunchTime: "",
					supperTime: "",
					lunchTimeStart: "", //晚餐时间
					lunchTimeMiddle: "", //晚餐时间
					lunchTimeEnd: "", //晚餐时间
					supperTimeStart: "", //晚餐时间
					supperTimeMiddle: "", //晚餐时间
					supperTimeEnd: "", //晚餐时间
          dazhongPath: "",//大众点评小程序路径
          adsTargetType: 0, //广告跳转类型 1大众点评 2美团
          adsTargetPath: "", //广告跳转路径
          adsVoucherImg: "", //代金券广告图片
          lang: "",
				},
        checkLang: [],
				id: "",
				addhiar: [],
				dialogVisible: false,
				center: {
					lng: 0,
					log: 0
				},
				zoom: 8,
				addressKeyword: "", // 地理位置
				forms: [],
				options: [], // 门店营业期限
				textAreaVal: "",
				labelname: "",
				ljnamelngth: 0,
				ljname: "",
				sharemoney: "", //分享获得奖励
				city: [],
				//状态
				statelist: [{
					value: 1,
					label: "正常营业"
				}, {
					value: 2,
					label: "门店撤店"
				}, {
					value: 3,
					label: "即将开业"
				}, {
					value: 4,
					label: "门店调休"
				}, {
					value: 5,
					label: "暂停营业"
				}, {
					value: 6,
					label: "升级装修中"
				}],
				state: "",
				// 发型师表格
				tableData: [],
				newrili: new Date(),
				mycheckeds: [],
				checked: [],
				restList: [ //休息日
					{
						id: "1",
						name: '周一'
					}, {
						id: "2",
						name: '周二'
					}, {
						id: "3",
						name: '周三'
					}, {
						id: "4",
						name: '周四'
					}, {
						id: "5",
						name: '周五'
					}, {
						id: "6",
						name: '周六'
					}, {
						id: "7",
						name: '周日'
					},
				],
        wxMchIds:[
          {
            value: null,
            label: "请选择"
          },
          {
            value: "1567986141",
            label: "潮剪1(1567986141)"
          },
          {
            value: "1649448558",
            label: "潮剪2(1649448558)"
          },
          {
            value: "1711050546",
            label: "芭曲(1711050546)"
          },
          {
            value: "1746707021",
            label: "金碧(1746707021)"
          },
          {
            value: "1746721793",
            label: "关总(1746721793)"
          },
          {
            value: "1747266066",
            label: "深圳街铺门店(1747266066)"
          },
          {
            value: "1114472392",
            label: "深圳大学店(1114472392)"
          },
        ],
        platform: [
          {
            value: 1,
            label: "潮剪"
          },
          {
            value: 2,
            label: "芭曲"
          },
        ]
			}
		},
		filters: {
			typeFormat(type) {
				if (type == 0) return '店员';
				if (type == 1) return '店长';
				if (type == 2) return '试用期';
				return '/';
			},
			statusFormat(status) {
				if (status == 1) return '学习期';
				if (status == 2) return '待分配';
				if (status == 3) return '试用期';
				if (status == 4) return '在职-上班';
				if (status == 5) return '在职-调休';
				if (status == 6) return '在职-假期';
				if (status == 7) return '在职-休假';
				if (status == 8) return '离职';
				return '/'
			}
		},
		mounted() {
			this.$http.get("store/list?page=1&size=9999").then(function(res) {
				if (res.body.code == "200") {
					this.stolist = []
					for (let i in res.body.data.rows) {
						let a = {
							value: res.body.data.rows[i].id,
							label: res.body.data.rows[i].title
						}
					}
				}
			})
			// 获取发型师等级列表
			this.$http.get("dWorkerLevel/query").then(function(res) {
				this.fax = []
				for (let i = 0; i < res.body.data.length; i++) {
					var a = {
						label: res.body.data[i].title,
						value: res.body.data[i].id
					}
					this.fax.push(a)
				}
			})
			// 获取城市列表
			const provinces = require('province-city-china/dist/city.json');
			this.city = []
			for (let i = 0; i < provinces.length; i++) {
				var a = {
					label: provinces[i].name,
					value: provinces[i].name
				}
				this.city.push(a)
			}
			var oid = this.$route.query.id
			this.id = oid
			if (oid) {
				this.getli();
			}
			this.getHaircutList();
		},
		methods: {
			//获取剪发服务刘表
			getHaircutList() {
				this.$http.get("service/haircutList").then(res => {
					this.serviceList = res.body.data;
				})
			},
			handleCurrentChange(val) {
				this.hairlist.page = val
				this.gethairs()
			},
			// 发型师更换门店
			cgstore() {
				this.$http.get("store/checkStore?storeId=" + this.cityss + "&workerId=" + this.workid).then(function(res) {
					if (res.body.code == 200) {
						this.$message.success("更换成功")
						this.getli()
						this.changestore = false
					}
				})
			},
			//更换门店
			changesto(works) {
				this.workid = works
				this.changestore = true
			},
			//获取门店详情
			getli() {
				this.$http.get("store/get?id=" + this.id).then(function(res) {
					if (res.body.code == "200") {
						//编辑状态打开发型师和排班
						this.showfax = true
						this.list = res.body.data
						// 休息日
						this.list.isMember = this.list.isMember.toString()
						this.list.storeType = this.list.storeType.toString()
						this.list.isDist = this.list.isDist.toString()
						if (this.list.restDay == '0') {
							this.list.restDay = []
						} else {
							if (this.list.restDay != null) {
								if (this.list.restDay.indexOf(",") != -1) {
									this.list.restDay = this.list.restDay.split(",")
								} else {
									var tmp = []
									tmp.push(this.list.restDay)
									this.list.restDay = tmp
								}
							}
						}
            this.checkLang = this.list.lang.split(",")
						if (res.body.data.lunchTimeStart != null && res.body.data.lunchTimeStart != '')
							this.list.lunchTimeStart = res.body.data.lunchTimeStart.substring(0, 5)
						if (res.body.data.lunchTimeMiddle != null && res.body.data.lunchTimeMiddle != '')
							this.list.lunchTimeMiddle = res.body.data.lunchTimeMiddle.substring(0, 5)
						if (res.body.data.lunchTimeEnd != null && res.body.data.lunchTimeEnd != '')
							this.list.lunchTimeEnd = res.body.data.lunchTimeEnd.substring(0, 5)
						if (res.body.data.supperTimeStart != null && res.body.data.supperTimeStart != '')
							this.list.supperTimeStart = res.body.data.supperTimeStart.substring(0, 5)
						if (res.body.data.supperTimeMiddle != null && res.body.data.supperTimeMiddle != '')
							this.list.supperTimeMiddle = res.body.data.supperTimeMiddle.substring(0, 5)
						if (res.body.data.supperTimeEnd != null && res.body.data.supperTimeEnd != '')
							this.list.supperTimeEnd = res.body.data.supperTimeEnd.substring(0, 5)
						this.list.type = this.list.type.toString()
						this.center.lng = res.body.data.lng
						this.center.log = res.body.data.lat
						this.list.longTime = this.list.longTime + ""
						if (this.list.longTime == 0) {
							var times = []
							times[0] = new Date(this.list.storeStart)
							times[1] = new Date(this.list.storeEnd)
							this.list.businesstime = times
						}
						this.serviceIds.length = 0
						res.body.data.serviceList.split(",").forEach(ele => {
							this.serviceList.forEach(service => {
								if (service.id == ele) this.serviceIds.push(service)
							})
						})
					}
					this.getWorkerOfStore(this.id);
				})
			},
			// 获取门店发型师列表
			getWorkerOfStore(id) {
				this.$http.get("store/findDWorkerById?storeId=" + id).then(res => {
					this.tableData = res.body.data
				})
			},
			//删除门店发型师
			deletes(id) {
				this.$confirm('是否要离职该员工?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get("worker/del/" + id).then(function(res) {
						if (res.body.code == "200") {
							this.$message.success("离职成功")
							this.getli()
						}
					})
				})
			},
			goback() {
				this.$router.push({
					path: 'storeList',
					query: {
						id: 1
					}
				})
			},
			// 添加门店
			addsto() {
				if (this.showfax) {
					if (this.list.longTime == 0) {
						if (!this.list.businesstime) {
							this.$message.error("请选择营业时间")
							return false
						}
						this.list.storeStart = this.list.businesstime[0]
						this.list.storeEnd = this.list.businesstime[1]
					}
					this.list.serviceList = []
					this.serviceIds.forEach(ele => {
						this.list.serviceList.push(ele.id)
					})
					this.list.serviceList = this.list.serviceList.toString();
					this.list.lng = this.center.lng;
					this.list.lat = this.center.log;
					if (this.list.restDay.length == 0) {
						this.list.restDay = 0
					} else {
						if (this.list.restDay.length == 1) {
							this.list.restDay = this.list.restDay[0]
						}
						if (this.list.restDay.length > 1) {
							this.list.restDay = this.list.restDay.join(",")
						}
					}
					this.list.lunchTimeStart = this.list.lunchTimeStart + ":00"
					this.list.lunchTimeMiddle = this.list.lunchTimeMiddle + ":00"
					this.list.lunchTimeEnd = this.list.lunchTimeEnd + ":00"
					this.list.supperTimeStart = this.list.supperTimeStart + ":00"
					this.list.supperTimeMiddle = this.list.supperTimeMiddle + ":00"
					this.list.supperTimeEnd = this.list.supperTimeEnd + ":00"
          this.list.lang = this.checkLang.join(",")
					this.$http.post("store/edit", JSON.stringify(this.list)).then(function(res) {
						if (res.body.code == 200) {
							this.$message.success("编辑成功")
							this.$router.go(-1)
						}
					})
				} else {
					let a = JSON.parse(JSON.stringify(this.list))
					if (a.title == "") return this.$message.error("请输入门店名称")
					if (a.longTime == 0) {
						if (a.businesstime == "") return this.$message.error("请选择营业时间")
						a.storeStart = a.businesstime[0]
						a.storeEnd = a.businesstime[1]
					}
					a.businesstime = null
					a.restDay = 0
					if (a.lunchTimeStart && a.lunchTimeEnd && a.lunchTimeMiddle && a.supperTimeStart && a.supperTimeEnd &&
						a.supperTimeMiddle) {
						a.lunchTimeStart = a.lunchTimeStart + ":00"
						a.lunchTimeMiddle = a.lunchTimeMiddle + ":00"
						a.lunchTimeEnd = a.lunchTimeEnd + ":00"
						a.supperTimeStart = a.supperTimeStart + ":00"
						a.supperTimeMiddle = a.supperTimeMiddle + ":00"
						a.supperTimeEnd = a.supperTimeEnd + ":00"
					} else return this.$message.error("请完善门店就餐时间");
					// if (!a.lunchTimeStart || !a.lunchTimeEnd || !a.lunchTimeMiddle) return this.$message.error(
					// 	"请完善门店就餐时间");
					// if (!a.supperTimeStart || !a.supperTimeEnd || !a.supperTimeMiddle) return this.$message.error(
					// 	"请完善门店就餐时间");
					if (!a.zaoStart || !a.zaoEnd) return this.$message.error("请完善工作日门店营业时间");
					if (!a.wanStart || !a.wanEnd) return this.$message.error("请完善周末门店营业时间");
					if (!a.city) return this.$message.error("请选择城市");
					if (!a.address) return this.$message.error("请输入详细地址");
					if (this.center.lng == 0 && this.center.log == 0) return this.$message.error("请选择经纬度");
					if (!a.state) return this.$maessage.error("请选择门店状态")
					if (this.serviceIds.length = 0) return this.$maessage.error("请选择门店状态")
					a.type = Number(a.type);
					a.lng = this.center.lng;
					a.lat = this.center.log;
					a.serviceList = [];
					this.serviceIds.forEach(ele => {
						a.serviceList.push(ele.id);
					})
					a.serviceList = a.serviceList.toString();
          a.lang = this.checkLang.join(",")
					this.$http.post("store/edit", JSON.stringify(a)).then(function(res) {
						if (res.body.code == 200) {
							this.$message.success("添加门店成功");
							this.$router.go(-1);
						}
					})
				}
			},
			// 获取发型师列表
			gethairs() {
				this.$http.get("store/otherWorker?name=" + this.hairlist.faxingshi + "&page=" + this.hairlist.page +
					"&size=" + this.hairlist.size).then(function(res) {
					if (res.body.code == 200) {
						this.barber = res.body.data.records;
						this.hairlist.total = res.body.data.total;
						this.getli();
					}
				})
			},
			//添加发型师
			addhair() {
				this.dialogVisible = true;
				this.gethairs();
			},
			// 确定添加发型师
			addstorehair() {
				var arr = {
					storeId: this.$route.query.id,
					workerIds: this.hairchecked
				}
				if (arr.workerIds.length == 0) {
					return this.$message.error("请选择发型师")
				}
				this.$http.post("store/addWorker", JSON.stringify(arr)).then(function(res) {
					if (res.body.code == 200) {
						this.$message.success("添加成功")
						this.dialogVisible = false
						this.gethairs() // 获取发型师列表
						this.getli() // 获取页面数据
					}
				})
			},
			hairchange() {
				console.log(this.hairchecked)
			},
			map_handler({
				BMap,
				map
			}) {
				console.log(BMap, map)
			},
			//获取门店经纬度
			getClickInfo(e) {
				this.center.lng = e.point.lng; //经度
				this.center.log = e.point.lat; //纬度

        // // 1. 先获取百度坐标 (BD09)
        // const bdLng = e.point.lng;
        // const bdLat = e.point.lat;
        //
        // // 2. 转换为 GCJ02 (火星坐标)
        // const gcj02 = coordtransform.bd09togcj02(bdLng, bdLat);
        //
        // // 3. 将转换后的坐标赋值给表单
        // // 使用 toFixed(6) 保留6位小数，再用 parseFloat 转回数字类型
        // this.center.lng = parseFloat(gcj02[0].toFixed(6));
        // this.center.log = parseFloat(gcj02[1].toFixed(6));
        //
        // console.log("原始百度坐标:", bdLng, bdLat)
        // console.log("截取后的火星坐标:", this.center.lng, this.center.log)
			},
		}
	};
</script>
<style lang="less" scoped>
	.headlike {
		width: 80px;
		height: 80px;
		border-radius: 50%;
		overflow: hidden;
	}

	.wailianjie {
		display: flex;

		/deep/ .wailj_title {
			width: 100px;
		}
	}

	.dialog-footer {
		width: 100%;
		margin-left: 250px;
	}

	.button_s {
		margin-left: 250px;
		margin-top: 30px;
	}

	.list1 {
		>div {
			padding-left: 50px;

			p {
				width: 233px;
				height: 47px;
				font-size: 14px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #C8C8C8;
				line-height: 2.1;
			}
		}
	}

	.heads {
		line-height: 1;
	}

	// 标题
	.waititle {
		width: 100%;
		font-weight: bold;
		display: flex;
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3e3e3e;

		.waititle1 {
			display: flex;
			flex: 1;
		}

		.waititle2 {
			display: flex;
		}

		.blue {
			width: 5px;
			position: relative;
			top: 3px;
			height: 15px;
			background: #409eff;
			border-radius: 2px;
			margin-right: 10px;
			margin-bottom: 20px;
		}
	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	.title2 {
		margin-top: 30px;
		margin-bottom: 30px;
	}

	.wais {
		display: flex;
	}

	.wai2 {
		margin: auto;

		.demo2 {
			width: 308px;
			height: 528px;
			background: #ECECEC;
			border-radius: 10px;
			padding-top: 30px;
			box-sizing: border-box;

			.img1 {
				width: 94px;
				height: 94px;
				border-radius: 7px;
				overflow: hidden;
				margin: auto;

				img {
					width: 100%;
					height: 100%;
				}
			}

			p {
				width: 100%;
				text-align: center;
				font-size: 16px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #3E3E3E;
			}

			.img2 {
				width: 96px;
				height: 97px;
				border-radius: 7px;
				overflow: hidden;
				margin: auto;
				margin-top: 200px;

				img {
					width: 100%;
					height: 100%;
				}
			}
		}
	}

	.addhair {
		text-align: center;
		font-size: 14px;
		text-align: center;
		line-height: 25px;
		color: #BABABA;
		width: 120px;
		height: 25px;
		border: 1px dashed #BABABA;
		margin-top: 10px;
		margin-bottom: 10px;
		cursor: pointer;
	}

	.paiban {
		display: flex;

		>div:nth-child(1) {
			flex: 2;
		}

		>div:nth-child(2) {
			flex: 1;
		}

		.worker {
			box-sizing: border-box;
			padding-left: 100px;
			padding-top: 80px;
			display: flex;

			>div:nth-child(1) {
				margin-left: 80px;

				>div {
					margin-top: 15px;
				}
			}

			>div:nth-child(2) {
				margin-left: 10px;

				>div {
					margin-top: 15px;
				}
			}
		}
	}

	.mberupload {
		margin-left: 40px;

		p {
			width: 300px;
			font-size: 14px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #C8C8C8;
			line-height: 1.6;
		}
	}

	.pages {
		margin-top: 8px;
		margin-bottom: 8px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}
</style>
